import getReportDetail from '../../../actions/api/report/getReportDetail';
import { REPORT_STATUS } from '../../../lib/constants';
import { OPEN_USER_PROMPT } from '../../../actions/actionTypes';
import { i18nMessages } from '../../../actions/api/apis';

/**
 * 報告書ステータスを確認して完了の場合はダイアログを表示する。
 * @param {string} apiToken APIトークン
 * @param {string} targetGroupId グループID
 * @param {Object} reportInfo レポート情報
 * @param {Function} dispatch dispatch関数
 */
const checkReportStatus = async (
  apiToken,
  targetGroupId,
  reportId,
  dispatch,
) => {
  // 報告書ステータスが完了の場合、報告書プレビュー画面へ遷移する。
  const resDetail = await dispatch(
    getReportDetail(apiToken, targetGroupId, reportId),
  );
  if (resDetail?.data?.status === REPORT_STATUS.COMPLETE) {
    const promptMessage = [
      i18nMessages['userPrompt.message.reportStatusChanged.complete1'],
      i18nMessages['userPrompt.message.reportStatusChanged.complete2'],
    ];

    dispatch({
      type: OPEN_USER_PROMPT,
      promptMessage,
      buttonArray: [{ name: i18nMessages['userPrompt.button.close'] }],
    });
  }
};

export default checkReportStatus;
